
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100%","height":"100%","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.33337 3.99996L8.85337 3.03329C8.74004 2.80663 8.50671 2.66663 8.25337 2.66663H4.00004C3.63337 2.66663 3.33337 2.96663 3.33337 3.33329V13.3333C3.33337 13.7 3.63337 14 4.00004 14C4.36671 14 4.66671 13.7 4.66671 13.3333V9.33329H8.00004L8.48004 10.3C8.59337 10.5266 8.82671 10.6666 9.07337 10.6666H12.6667C13.0334 10.6666 13.3334 10.3666 13.3334 9.99996V4.66663C13.3334 4.29996 13.0334 3.99996 12.6667 3.99996H9.33337ZM12 9.33329H9.33337L8.66671 7.99996H4.66671V3.99996H8.00004L8.66671 5.33329H12V9.33329Z","fill":"currentColor"}})])
          )
        }
      }
    